import useTranslate from "../../../core/languages/hooks/useTranslate";
import React, { useRef } from "react";
import { BookingFilters } from "../../../booking/hooks/useBookingMeSearchData";

interface Props {
    query: BookingFilters;
    onChange: (updates: Partial<BookingFilters>) => void;
}

const ConfirmationNumberFilter: React.FC<Props> = ({ query, onChange }) => {
    const t = useTranslate();
    const confirmationRef = useRef<HTMLInputElement | null>(null);

    // Focus input when container is clicked
    const handleContainerClick = () => {
        confirmationRef.current?.focus();
    };

    return (
        <div
            className="relative w-60 cursor-pointer items-center min-w-0 [ nc-hero-field-padding ]"
            onClick={handleContainerClick}
        >
            <div className="flex-grow min-w-0">
                <input
                    ref={confirmationRef}
                    value={query.confirmationNo || ""}
                    onChange={(e) => onChange({ confirmationNo: e.target.value })}
                    placeholder={t("bookingMeForm.confirmationNumber")}
                    className="w-full min-w-0 bg-transparent border-none focus:outline-none focus:ring-0 p-0 xl:text-lg font-semibold placeholder-neutral-800 dark:placeholder-neutral-200 focus:placeholder-neutral-400"
                />
                <span className="block mt-0.5 text-sm text-neutral-400 font-light whitespace-normal break-words">
                    {t("bookingMeForm.searchByConfirmationNumber")}
                </span>
            </div>
        </div>
    );
};

export default ConfirmationNumberFilter;
